import React from 'react';
import {Alert, Badge, Button, UncontrolledTooltip} from "reactstrap";
import {faBoxesPacking, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const QuoteReservesBadge = ({ name, quote, children, text="Inventory Reserved", icon=faExternalLink  }) => {
    if(quote.reserve?.saturnReserveData == null)
        return;
    const id = `reserve-badge-${quote.id}-${name}`;
    return (
                <>
                    <a
                        href={`https://web.warehouseparadise.com/admin/reserves/${quote.reserve.saturnReserveData.id}/edit`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span
                            id={id}
                            color={"warning"}
                            className="me-2 badge warning-badge warning"
                            >
                            {text} <FontAwesomeIcon icon={icon} className="ms-1" />
                        </span>
                        <UncontrolledTooltip placement="top" target={id}>
                            Inventory is Reserved. Click to view in Saturn
                        </UncontrolledTooltip>
                    </a>
                    {children}
                </>
    );
}
export default QuoteReservesBadge;
